module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.showModalNegar) ? _c('modal-negar', {
    on: {
      "close": function($event) {
        _vm.showModalNegar = false
      },
      "negar": function (motivo, observacao) { return _vm.negar(motivo, observacao); }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModalAcertoAtendimento) ? _c('modal-acerto-atendimento', {
    attrs: {
      "boletoId": _vm.controle.boleto_id
    },
    on: {
      "close": function($event) {
        _vm.showModalAcertoAtendimento = false
      },
      "updateBoleto": function (boletoId, dados) { return _vm.updateBoleto(boletoId, dados); }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Dados da Solicitação")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.dados.id) + "-" + _vm._s(_vm.dados.digito))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(_vm.dados.data)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.usuario.empresa.fantasia))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.telefone1) + " " + _vm._s(_vm.dados.pessoa.telefone2 && _vm.dados.pessoa.telefone2 != '' ? (" " + (_vm.dados.pessoa.telefone2)) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.qtd_titulo))]), _vm._v(" "), _c('td', [_c('strong', {
    class: _vm.dados.status
  }, [_vm._v(_vm._s(_vm.dados.status))])])])])]), _vm._v(" "), (_vm.dados.motivo || _vm.dados.observacao) ? _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.dados.motivo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.observacao))])])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.dados.pessoa.endereco))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.complemento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.bairro))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.cidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.uf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.ref_comercial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.tel_ref_comercial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.ref_pessoal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.tel_ref_pessoal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dados.pessoa.ocupacao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.dados.pessoa.renda, 2, ',', '.')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box collapsed-box solid"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.documentacao), function(documento, key) {
    return _c('div', {
      key: key,
      staticClass: "col-sm-10 col-sm-offset-2",
      staticStyle: {
        "margin-top": "12px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "600px",
        "height": "400px"
      },
      attrs: {
        "src": documento
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box collapsed-box solid"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.duplicatas), function(duplicata, key) {
    return _c('div', {
      key: key,
      staticClass: "col-sm-10 col-sm-offset-2",
      staticStyle: {
        "margin-top": "12px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "600px",
        "height": "400px"
      },
      attrs: {
        "src": duplicata
      }
    })])
  }), 0)])]), _vm._v(" "), _c('h4', [_vm._v("Dados dos Boletos")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.dados.boletos), function(boleto) {
    return _c('tr', {
      key: boleto.id,
      staticClass: "odd",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(boleto.id) + "-" + _vm._s(boleto.digito))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(boleto.valor, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(boleto.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(boleto.situacao))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "title": "Acerto de Atendimento"
      },
      on: {
        "click": function($event) {
          return _vm.getModalAcertoAtendimento(boleto.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit"
    })]), _vm._v(" "), (boleto.situacao == 'DISPONÍVEL PARA PAGAMENTO' || boleto.situacao == 'ENVIADO PARA REGISTRO' || boleto.situacao == 'GARANTIDO') ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Cancelar"
      },
      on: {
        "click": function($event) {
          return _vm.cancelarBoleto(boleto.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-close"
    })]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('h4', [_vm._v("Boletos Anteriores")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_vm._l((_vm.dados.pessoa.garantias), function(garantia) {
    return (_vm.dados.id != garantia.id && _vm.dados.id > garantia.id) ? _vm._l((garantia.boletos), function(boleto) {
      return _c('tr', {
        key: boleto.id,
        staticClass: "odd",
        staticStyle: {
          "color": "red"
        },
        attrs: {
          "role": "row"
        }
      }, [_c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(boleto.valor, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(boleto.vencimento)))])])
    }) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlConsultaRestritiva)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlConsultaAnalitica)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.dados.status == 'APROVADO' && _vm.dados.libera_boleto != 'S') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.liberaBoleto
    }
  }, [_vm._v("Libera Boleto(s)")]) : _vm._e(), _vm._v(" "), (_vm.dados.status == 'PENDENTE') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.aprovar
    }
  }, [_vm._v("Aprovar")]) : _vm._e(), _vm._v(" "), (_vm.dados.status == 'PENDENTE') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.showModalNegar = true
      }
    }
  }, [_vm._v("Negar")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": _vm.htmlConsultaAnalitica != ''
    },
    on: {
      "click": _vm.consultaAnalitica
    }
  }, [_vm._v("Consulta Analítica")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.htmlConsultaRestritiva != ''
    },
    on: {
      "click": _vm.consultaRestritiva
    }
  }, [_vm._v("Consulta Restritiva")]), _vm._v(" "), (_vm.dados.status == 'APROVADO') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        return _vm.cancelarGarantia()
      }
    }
  }, [_vm._v("Cancelar Garantia")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default"
  }, [_vm._v("Voltar")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Análise da Garantia")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Protocolo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "18%"
    }
  }, [_vm._v("Pessoa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("Cpf/Cnpj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "22%"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("Quant.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Situação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Observação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Ref. Comercial")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Ref. Pessoal")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Ocupação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Renda")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentação")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Duplicatas Assinadas")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Garantia")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Vencimento")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a19638"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operacao/garantias/detalhe.vue
// module id = 406
// module chunks = 1